import React, { useState } from "react";
import { useNavigate } from "react-router-dom";  

const PosInvoiceTable = ({
    data = [],
    columns,
    showAction,
    showFooter,
    handlePrint
}) => {
    const [sortConfig, setSortConfig] = useState({
        key: null,
        direction: "ascending",
    });
    const [searchTerm, ] = useState("");

    const navigate = useNavigate();  

    const filterData = (dataToFilter) => {
        if (!searchTerm) return dataToFilter;
        return dataToFilter.filter((item) =>
            Object.values(item).some((value) =>
                String(value).toLowerCase().includes(searchTerm.toLowerCase())
            )
        );
    };

    const sortDisplayedData = (dataToSort) => {
        let sortableItems = [...dataToSort];
        if (sortConfig.key) {
            sortableItems.sort((a, b) => {
                if (a[sortConfig.key] < b[sortConfig.key]) {
                    return sortConfig.direction === "ascending" ? -1 : 1;
                }
                if (a[sortConfig.key] > b[sortConfig.key]) {
                    return sortConfig.direction === "ascending" ? 1 : -1;
                }
                return 0;
            });
        }
        return sortableItems;
    };

    const filteredData = filterData(data);
    const sortedDisplayedData = sortDisplayedData(filteredData);

    const handleSort = (key) => {
        let direction = "ascending";
        if (sortConfig.key === key && sortConfig.direction === "ascending") {
            direction = "descending";
        }
        setSortConfig({ key, direction });
    };

    const statusStyles = {
        enable: {
            backgroundColor: "#6CBE1C", 
            color: "#fff",
            borderRadius: "30px",
            padding: "5px 10px",
        },
        disable: {
            backgroundColor: "#F6F6F6", 
            color: "#fff",
            borderRadius: "30px",
            padding: "5px 10px",
        },
        draft: {
            backgroundColor: "#D1D1EF",
            color: "#fff",
            borderRadius: "30px",
            padding: "5px 10px",
        },
        unpaid: {
            backgroundColor: "#EF3E49",
            color: "#fff",
            borderRadius: "30px",
            padding: "5px 10px",
        },
        paid: {
            backgroundColor: "#5856AC",
            color: "#fff",
            borderRadius: "30px",
            padding: "5px 10px",
        },
    };

    const handleShowAllClick = () => {
        navigate("/invoice-pos-history");  
    };

    return (
        <div className="data-table-container">

            <div className="" style={{
            justifyContent: "space-between", 
            gap: "10px", 
            width: "100%", 

          }}>

            <table className="data-table custom-table" style={{ borderRadius: "none" ,}}>
                <thead className="table-header" style={{ fontSize:'13px' }}>
                    <tr>
                        {columns.map((col, index) => (
                            <th key={index} scope="col" onClick={() => handleSort(col.field)}>
                                {col.header}
                                {sortConfig.key === col.field &&
                                    (sortConfig.direction === "ascending" ? (
                                        <svg
                                            width="8"
                                            height="4"
                                            viewBox="0 0 8 4"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                            style={{ marginLeft: "5px" }}
                                        >
                                            <path d="M0 4L4 0L8 4H0Z" fill="#000000" />
                                        </svg>
                                    ) : (
                                        <svg
                                            width="8"
                                            height="4"
                                            viewBox="0 0 8 4"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                            style={{ marginLeft: "5px" }}
                                        >
                                            <path d="M0 0L4 4L8 0H0Z" fill="#000000" />
                                        </svg>
                                    ))}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody className="table-body">
                    {sortedDisplayedData.length === 0 ? (
                        <tr>
                            <td
                                colSpan={columns.length + (showAction ? 1 : 0)}
                                style={{
                                    textAlign: "center",
                                    
                                    fontWeight: "600",
                                    fontSize: "16px",
                                    background:
                                        "linear-gradient(180deg, rgba(255, 255, 255, 0.1) -92.86%, #4A5546 71.43%)",
                                    WebkitBackgroundClip: "text",
                                    WebkitTextFillColor: "transparent",
                                }}
                            >
                                No data found
                            </td>
                        </tr>
                    ) : (
                        sortedDisplayedData.map((item) => (
                            <tr key={item.id || item.index}>
                                {columns.map((col, colIndex) => (
                                    <td key={colIndex}>
                                        {col.field === "status" ? (
                                            <div style={statusStyles[item[col.field]]}>
                                                {typeof item[col.field] === "string" && item[col.field]
                                                    ? item[col.field].charAt(0).toUpperCase() + item[col.field].slice(1)
                                                    : "-"}
                                            </div>
                                        ) : item[col.field] !== undefined && item[col.field] !== null ? (
                                            Array.isArray(item[col.field])
                                                ? item[col.field].join(", ")
                                                : (typeof item[col.field] === "function"
                                                    ? item[col.field]()
                                                    : item[col.field])
                                        ) : (
                                            "-"
                                        )}
                                    </td>
                                ))}
                            </tr>
                        ))
                    )}
                </tbody>
            </table>

            {showFooter && (
                <div className="pagination">
                    <button
                        onClick={handleShowAllClick}  
                        style={{ marginBottom: "10px", backgroundColor: '#4A5546', color: '#FFFFFF', width: "190px", height: "35px", borderRadius: '10px' , fontSize:'15px'}}
                    >
                        Show All Invoices
                    </button>
                </div>
            )}
        </div>
             </div>
    );
};

export default PosInvoiceTable;